import { request } from '~/services/request'

/**
 * 搜索列表
 *
 * @param {*} params
 * @return {*}
 */
export const getSeachlist = (params: any): any => {
  return request.get('/search', { params })
}

/**
 * 搜索建议
 * @param {string} q - 搜索关键字
 */
export const searchSuggestAPI = (q: string) => {
  return request.get('/search/suggest', { params: {
    limit: 5,
    q,
  } })
}
